import React, { useMemo } from 'react';

import { useStyles } from './style';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { useGetInvoicesQuery } from '../../../../api/payment-method';
import { OpLoading } from '../../../../shared/components/op-loading';
import { TransactionItem } from './TransactionItem';

export const SupplierTransactions: React.FC = () => {
  const classes = useStyles();
  const {data: invoicesData, isLoading: invoicesLoading } = useGetInvoicesQuery();

  const isEmptyData = useMemo(() => {
    return invoicesData?.invoices.length === 0;
  }, [invoicesData]);

  return (
    <>
      <OpLoading loading={invoicesLoading} dataLoaded={!invoicesLoading}>
        {isEmptyData && <Typography className={classes.noTransactions}>
          No transactions
        </Typography>}

        {!isEmptyData && <Table stickyHeader>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell className={classes.tableHeadCell} style={{textAlign: 'center', width: '49%'}}>Description</TableCell>
              <TableCell className={classes.tableHeadCell} style={{width: '17%'}}>Invoice date</TableCell>
              <TableCell className={classes.tableHeadCell} style={{width: '17%'}}>Status</TableCell>
              <TableCell className={classes.tableHeadCell} style={{width: '17%'}}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoicesData?.invoices?.map((invoice) => (
                <TransactionItem invoice={invoice} />
            ))}
          </TableBody>
        </Table>}
      </OpLoading>
    </>
  );
};
